import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Invite, InvitePost } from '@mkp/account-membership/models';
import { CoreListEnvelop } from '@mkp/shared/models';
import { BaseHttpResource } from '@mkp/shared/data-access';
import { Observable } from 'rxjs';
import { InviteDto } from './invite.dto';
import { decodePunycodeEmail } from '@mkp/shared/util-format';

@Injectable({ providedIn: 'root' })
export class InviteResource extends BaseHttpResource<Invite, CoreListEnvelop<Invite>, InvitePost> {
  constructor() {
    super('account-membership-invite');
  }

  protected override mapDto(dto: Invite): Invite {
    return {
      ...super.mapDto(dto),
      email: decodePunycodeEmail((dto as unknown as InviteDto).email ?? dto.email),
    };
  }

  redeemInvite(token: string): Observable<void> {
    return this.http.post<void>(
      `${this.url}/redeem`,
      { token },
      { headers: new HttpHeaders({ maxRetry: 1 }) }
    );
  }
}
